import React from 'react';
import './style.scss';
import { useNavigate } from 'react-router-dom';
import getFirstNode from 'utils/getFirstNode';
import { useSelector } from 'react-redux';
import { getRegion } from 'utils/Region';
import { getClaroAdsKey } from 'utils/claroAds/getClaroAdskey';
import { ClaroTVLogo } from '../ClaroTVLogo';

export const QRLinkingHeader = () => {
  const claroLiteConfig = useSelector(state => getClaroAdsKey(state));

  const navigate = useNavigate();
  const firstNode = getFirstNode(claroLiteConfig);

  return (
    <div className="QRLinkingHeader">
      <ClaroTVLogo onClick={() => navigate(`/${getRegion()}/${firstNode}`)} />
    </div>
  );
};
